<template>
  <v-card-text style="padding: 0px">
    <div class="req-attachment">
      <div class="card">
        <v-row class="">
          <v-col cols="6">{{ $t('add_file') }}</v-col>
          <v-col class="text-end" style="padding: 0px" cols="6">
            <v-btn
              color="primary"
              dark
              @click="select_file()"
              class="ma-2"
            >
              <v-icon
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row>
      <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden
             v-on:change="input_file_changed">
      <v-row style="margin-bottom: 35px; margin-top: 35px;">
        <v-col cols="4"
               v-for="(item, i) in files"
               :key="i"
        >
          <v-icon v-on:click="delete_file(i)" style="color: crimson">
            mdi-close
          </v-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
          <img style="height: 100px!important;width: 100px!important;" loading="lazy" :src="item.file" width="100px"
               height="100px"/>

        </v-col>
      </v-row>
    </v-row>
<v-row>
  <v-col cols="4" v-for="item in JSON.parse(items)">
    <img
      @click="open_image('https://'+item.ArchivePath)"
      :src="'https://'+item.ArchivePath" width="100%" height="auto"/>

  </v-col>
</v-row>
    <v-btn color="primary m-0" class="btn-end" v-on:click="save()">
      {{$t('sendFiles')}}
    </v-btn>

    <v-row justify="center">
      <v-dialog
        v-model="dialog_camera"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialog_camera = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{$t('camera')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="downloadImage()"
              >
                {{$t('save')}}
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <div v-if="isCameraOpen" class="camera-box">
            <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
          </div>
          <div v-if="isCameraOpen" class="camera-shoot">
            <v-btn type="button" class="button" @click="takePhoto">
              <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
            </v-btn>
          </div>
          <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
            <!--            <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">-->
            <!--              Download-->
            <!--            </a>-->
          </div>
        </v-card>
      </v-dialog>
    </v-row>

  </v-card-text>

</template>

<script>
import {bus} from '../../../main'

export default {
  name: 'Attachments',
  data() {
    return {
      files: [],
      items: "[]",
      dialog_camera: false,
      isCameraOpen: false,
      isPhotoTaken: false
    }
  },
  mounted() {
    this.get_attachments()

    // console.log("rec id",this.$route.params.rec_id)
  },
  watch: {},
  props:{
    master_id:String,
    doc_type:String,
  },
  methods: {
    open_image(img) {
      window.open(img, '_blank')
    },
    save() {
      if (this.files.length) {
        this.upload_image(0)

      } else {
        this.$router.go(-1)
      }
    },
    select_file() {

      document.getElementById('fileUpload').click()
    },
    open_camera() {
      this.isCameraOpen = true
      this.createCameraElement()
    },
    delete_file(index) {
      this.files.splice(index, 1)
    },
    takePhoto() {
      this.isPhotoTaken = true

      const context = this.$refs.canvas.getContext('2d')
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5)
    },
    downloadImage() {
      if (this.isPhotoTaken == true) {
        this.isCameraOpen = false
        // const download = document.getElementById("downloadPhoto");
        const preview = document.getElementById('photoTaken')
        const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
        // .replace("image/jpeg", "image/octet-stream");
        var obj = {file: canvas, preview: preview, upload: 0}
        this.files.push(obj)
        this.dialog_camera = false
        this.isPhotoTaken = false
      }
      // download.setAttribute("href", canvas);
    },
    input_file_changed() {
      // console.log("input_file_changed")
      var self = this

      var reader = new FileReader()
      var f = document.getElementById('fileUpload').files
      // if (f != null) {
      reader.onloadend = function () {
        // console.log(reader.result);
        if (!reader.result.startsWith('data:image/webp')) {
          self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
            // $("body").append(newImg[0]);
            var obj = {file: newImg[0].src, preview: reader.result, upload: 0}
            self.files.push(obj)
            reader = null;
            f = null;
            document.getElementById('fileUpload').files = null;
            obj = null;
          })
          // console.log(obj)
        } else {
          bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
        }
      };
      reader.readAsDataURL(f[0])

      // }

    },

    createCameraElement() {
      try {
        const constraints = (window.constraints = {
          audio: false,
          video: true
        })

        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.$refs.camera.srcObject = stream
          })
          .catch(error => {
            alert(this.$t('deviceHasNoCamera'))
          })
      } catch (err) {
        alert(err)
      }
    },
    async resizeBase64Img(base64, minimum) {
      // try {

      var canvas = document.createElement('canvas')

      var deferred = $.Deferred()
      $('<img/>').attr('src', base64).load(function () {
        var last_width = this.width
        var last_height = this.height

        if (last_width > last_height) {
          last_width = (last_width * minimum) / last_height
          last_height = minimum
        } else {
          last_height = (last_height * minimum) / last_width
          last_width = minimum
        }
        canvas.width = last_width
        canvas.height = last_height
        var context = canvas.getContext('2d')

        // console.log(this.width, this.height)
        context.scale(last_width / this.width, last_height / this.height)
        context.drawImage(this, 0, 0)

        deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
      })
      return deferred.promise()
      // } catch (e) {
      //   bus.$emit('show_toast', [3000, "error on Base64Img"])
      //
      // }
    },
    upload_image(index) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var form_data = new FormData()
      form_data.append('UserId', user_id)
      form_data.append('ProcessId', this.$route.params.rec_id)
      form_data.append('Format', 'png')
      form_data.append('ReqType', 13)
      form_data.append('DocType', 1)
      var my_file = this.files[index].file

      var file = this.dataURLtoFile(my_file, 'attach.png')
      form_data.append('Picture', file)

      this.axios.post('UploadFile', form_data, {})
        .then(response => {
          // self.send_signature(response.data.ArchiveId,response.data.ImageName);
          if (response.data.error == 0) {
            self.files[index].upload = 1
            self.files[index].ArchiveId = response.data.ArchiveId
            self.files[index].ImageName = response.data.ImageName
            if (index < self.files.length - 1) {
              self.upload_image(index + 1)
            } else {
              self.send_attach(0)
            }

          } else {
            self.files[index].upload = 2
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    dataURLtoFile(dataurl, filename) {
      try {

        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, {type: mime})
      } catch (e) {
        bus.$emit('show_toast', [3000, "error on dataURLtoFile"])

      }
    },

    send_attach(index_arr) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      // console.log();

      var attachment_array = []

      self.files.forEach(function (number) {
        var pre_obj = {
          ArchiveId: number.ArchiveId,
          ImageName: number.ImageName,
          Summary: '',
        }
        attachment_array.push(pre_obj)
      })

      const send_data = {
        ArchiveId: attachment_array[index_arr].ArchiveId,
        FileName: attachment_array[index_arr].ImageName,
        UserId: user_id,
        DocCode: this.doc_type,
        MasterId: this.master_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddAccDocFile', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            if(index_arr < (self.files.length-1)){
              self.send_attach(index_arr+1)
            }else{
              self.$router.go(-1)
            }
          } else {
            bus.$emit('show_toast', [2000, response.data.msg + " " + JSON.stringify(send_data)])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_attachments() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      // console.log();

      var attachment_array = []

      const send_data = {
        UserId: user_id,
        MasterId: this.master_id,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetKardexMasterFiles_ById', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
           self.items = response.data.dataa
          } else {
            bus.$emit('show_toast', [2000, response.data.msg + " " + JSON.stringify(send_data)])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    }

  }
}
</script>
